var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#EB2019"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2803 46.0917C21.6336 39.1309 24.6065 32.8258 29.5374 28.82C31.4595 27.2572 34.3336 28.5954 34.3336 31.0654C34.3336 31.9725 33.9025 32.8078 33.2019 33.3737C29.7081 36.2208 27.6064 40.7117 28.1183 45.6695C28.783 52.1273 33.9564 57.3547 40.4052 58.0732C48.821 59.0163 55.9704 52.4237 55.9704 44.1966C55.9704 39.8315 53.9495 35.9245 50.797 33.3647C50.0964 32.7988 49.6743 31.9636 49.6743 31.0654C49.6743 28.6224 52.5035 27.2392 54.4076 28.7661C58.9164 32.4037 61.8085 37.9633 61.8085 44.1966C61.8085 55.5943 52.1263 64.7825 40.5489 63.9472C30.9745 63.2736 23.1694 55.6482 22.2803 46.0917ZM41.995 20C40.3783 20 39.0759 21.3113 39.0759 22.919V36.3646C39.0759 37.9813 40.3873 39.2836 41.995 39.2836C43.6027 39.2836 44.914 37.9723 44.914 36.3646V22.919C44.914 21.3113 43.6117 20 41.995 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPower);
export default __webpack_public_path__ + "static/media/icon-power.9d49f30d4309373b421e4f190e4d903f.svg";
export { ForwardRef as ReactComponent };